import client from "./base";
import { PresignedUrl } from "./inventoryImport";

export const getRequiredHeaders = async (adminId: number) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/phar-group/import-jobs/required-headers`

    return client.get<string[]>(path);
}

export const getUploadPresignedUrl = async (adminId: number, fileName: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/phar-group/import-jobs/upload-pre-signed-url`


    return client.post<PresignedUrl>(path, { fileName });
}

export const getReadPresignedUrl = async (adminId: number, fileKey: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/phar-group/import-jobs/read-file-pre-signed-url`


    return client.post<PresignedUrl>(path, { fileKey });
}

export const importInventoryData = async (adminId: number, fileUrl: string, fileName: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/phar-group/import-jobs`

    return client.post<any>(path, { fileName, fileUrl });
}